.scroll-container {
    max-height: calc(100vh - 320px);
    overflow-y: auto;
}
